<template>
  <IndicacionFlujoCompraBaterias v-if="modo_sistema === NEGOCIOS.BATERIAS" />
  <IndicacionFlujoCompraNeumaticos v-if="modo_sistema === NEGOCIOS.NEUMATICOS" />
</template>

<script setup>
import IndicacionFlujoCompraBaterias from "~/components/Home/Battery/IndicacionFlujoCompraBaterias.vue";
import IndicacionFlujoCompraNeumaticos from "~/components/IndicacionFlujoCompraNeumaticos.vue";

import { NEGOCIOS } from "~/constants/negocios";
const modo_sistema = useState('modo_sistema');

onMounted(() => {
  //console.log("debug0409- modo_sistema.value: ", modo_sistema.value);
});
</script>